export const YOUTUBE_CHANNEL_ID = "UCOBLOXs2Z0SzpvfcRkm5Szw";

export const YOUTUBE_API_KEY =  `${process.env.REACT_APP_GOOGLE_API_KEY}`

export const VIDEO_LIBRARY_CHAT_EMAIL = `${process.env.REACT_APP_VIDEO_LIBRARY_EMAIL}`

export const VIDEO_API_URL = `https://youtube.googleapis.com/youtube/v3/channels?key=${YOUTUBE_API_KEY}&id=${YOUTUBE_CHANNEL_ID}&part=contentDetails&type=video&maxResults=10`;

export const getPlaylistVideoAPI = (playListId, token) => {
    return `https://youtube.googleapis.com/youtube/v3/playlistItems?key=${YOUTUBE_API_KEY}&playlistId=${playListId}&part=snippet&maxResults=50&pageToken=${token}`
}

export const VIDEO_LIBRARY_EMAIL_API_GATEWAY_BASE_URL = 'https://ssaqmfpcb7.execute-api.us-east-1.amazonaws.com/Prod'

export const VIDEO_LIBRARY_MAIN_VIDEO_API_GATEWAY_BASE_URL = "https://jb8rardii5.execute-api.us-east-1.amazonaws.com/Prod"
